@let item = freight();
<ion-item
  button="true"
  detail="true"
  [routerLink]="['/tabs/' + AppTab.FREIGHT_AVAILABLE, item.id]"
  routerDirection="root"
  routerLinkActive="active"
  [class.notAvailable]="isNotAvailable()"
>
  <ion-label>
    <ion-row>
      <ion-col size="6">
        <p class="date">
          {{ item.stops[0].since | dfnsFormat: 'ccc P' }}
        </p>
        @if (isFullyAvailable() || isAvailableWithConditions()) {
          <p>{{ item.stops[0].address.postalCode }} {{ item.stops[0].address.city }}</p>
        }
        <p class="state state--from">
          ({{ item.stops[0].address.countryCode }})
          {{ 'states.' + item.stops[0].address.countryCode + item.stops[0].address.stateCode | translate }}
        </p>
      </ion-col>
      <ion-col
        size="6"
        class="ion-text-end"
      >
        <p class="date">
          {{ item.stops[item.stops.length - 1].since | dfnsFormat: 'ccc P' }}
        </p>
        @if (isFullyAvailable() || isAvailableWithConditions()) {
          <p>
            {{ item.stops[item.stops.length - 1].address.postalCode }}
            {{ item.stops[item.stops.length - 1].address.city }}
          </p>
        }
        <p class="state state--to">
          ({{ item.stops[item.stops.length - 1].address.countryCode }})
          {{
            'states.' +
              item.stops[item.stops.length - 1].address.countryCode +
              item.stops[item.stops.length - 1].address.stateCode | translate
          }}
        </p>
      </ion-col>
    </ion-row>
    <ion-row class="additional-data">
      <ion-col>
        <span
          class="tag price"
          [class.notAvailable]="isNotAvailable()"
          [class.availableWithConditions]="isAvailableWithConditions()"
          [class.fullyAvailable]="isFullyAvailable()"
        >
          @if (item.price > 0) {
            {{ item.price | currency: 'EUR' : 'symbol' : '1.2-2' }}
          } @else {
            <span class="tag price">Consultar</span>
          }
        </span>

        @if (isFullyAvailable()) {
          <span class="tag available">
            <ion-icon
              aria-hidden="true"
              src="../assets/material-symbols/okc_freight_inprogress_24dp.svg"
            ></ion-icon>
          </span>
        }
        @if (item.distance) {
          <span class="tag distance">{{ item.distance }} km</span>
        }
        @if (item.price > 0 && item.pricePerKilometer) {
          <span class="tag price-per-kilometer">{{ item.pricePerKilometer }} €/km</span>
        }

        @if (item.stops.length > 2) {
          <span class="tag stops">
            <ion-icon
              aria-hidden="true"
              src="../assets/material-symbols/pin_drop_24dp.svg"
            ></ion-icon>
            +{{ item.stops.length - 2 }}
          </span>
        }
      </ion-col>
    </ion-row>
  </ion-label>
</ion-item>
